import { Icon } from '@amigoapp/doca-react';

const LiveKitModalClose = ({ onClick }) => (
	<button aria-label="Fechar" className="lk-modal__close" type="button" onClick={onClick}>
		<Icon name="xmark" type="solid" />
	</button>
);

export default LiveKitModalClose;
